// Text of the offer tag shown under a cart line ("" = no tag).
// - A discounted line: its rule's name (discountName), shown only while it carries a discount -- as before.
// - TSK-5562: a Total Discount - Free Product (TDF) offer line is repriced (Rs 99 / Rs 0), not discounted,
//   so it has no discount or discountName; it carries the rule's printed name in tdfOfferName instead.
//   discountName is deliberately not used for it: other code treats a line with a discountName as
//   discounted (remove-discount prompts, Remove All Discounts, Total Bill Discount line checks).
export const getLineOfferTag = (item) => {
  if (Math.abs(Number(item?.discount) || 0) > 0 && item?.discountName) return item.discountName;
  if (item?.isTdfProduct === true && item?.tdfOfferName) return item.tdfOfferName;
  return "";
};
